import { Col, Row, Modal, Form, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Dispatch } from "react";
import { BrandType } from "./brandType";
import { createBrand, editBrand } from "../../../api/brand";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";

type propsType = {
  Brand?: BrandType | undefined;
  openBrand: boolean;
  id?: string | number;
  setOpenBrand: React.Dispatch<React.SetStateAction<boolean>>;
  setPaginatedBrand: Dispatch<any>;
  BrandsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  filter: boolean | undefined;
  search: any;
  page: number;
};

export const AddEditBrand = ({
  openBrand,
  setOpenBrand,
  Brand,
  id,
  setPaginatedBrand,
  BrandsMutation,
  search,
  filter,
  page,
}: propsType) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [, setError] = useState("");

  const isEdit = () => {
    return !!id;
  };
  const [brand, setBrand] = useState(false);
  const handleInputChange = (value: any) => {
    setBrand(value);
  };
  const [editStatus] = useState(isEdit());
  useEffect(() => {
    if (editStatus) {
      setBrand(true);
    }
  }, [editStatus]);

  const onError = (error: any, variables: BrandType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createBrand" : "editBrand",
    !isEdit()
      ? (Brand: BrandType) => createBrand(Brand)
      : (Brand: BrandType) => editBrand(id, Brand),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenBrand(false);
        message.success("Complete successfully");
        BrandsMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedBrand(res.data);
        });
      },
      onError,
    }
  );

  const handleFinish = () => {
    const newBrand = form.getFieldsValue();
    for (const key in newBrand) {
      if (newBrand[key] === undefined) {
        if (key === "isActive") {
          newBrand[key] = true;
        } else {
          newBrand[key] = null;
        }
      } else if (
        typeof newBrand[key] === "string" &&
        newBrand[key].trim() === ""
      ) {
        newBrand[key] = null;
      }
    }
    mutateCreateUpdate(newBrand);
  };

  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        width={530}
        maskClosable={false}
        centered
        onCancel={() => setOpenBrand(false)}
        open={openBrand}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !brand,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Form
          className="no-hover-label"
          data-testid="form"
          layout="vertical"
          form={form}
          id="BrandForm"
          onFinish={handleFinish}
          initialValues={{
            isActive: isEdit() ? Brand?.isActive : true,
          }}
        >
          <Col offset={1}>
            {" "}
            <Title
              title={isEdit() ? `${t("edit-brand")}` : `${t("add-brand")}`}
            />
          </Col>
          {isEdit() && (
            <Col offset={1}>
              {" "}
              <span className="modaltitleEdit">
                {t("edit-details-for")} {Brand?.name}
              </span>
            </Col>
          )}
          <Row style={{ marginTop: "20px" }}>
            <Col span={14} offset={1}>
              <Form.Item
                initialValue={Brand?.name}
                name="name"
                label={t("brand-name")}
                rules={[
                  {
                    required: true,
                    message: "brand name is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  onChange={handleInputChange}
                  data-testid="Brand-input"
                />
              </Form.Item>

              <Form.Item
                name="abbreviation"
                label={t("abbreviation")}
                initialValue={Brand?.abbreviation}
              >
                <InputName
                  maxLength={20}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                  data-testid="abbreviation-input"
                />
              </Form.Item>
              {isEdit() ? (
                <Form.Item
                  label={`${t("status")}`}
                  name="isActive"
                  valuePropName={Brand?.isActive ? "checked" : ""}
                >
                  <Switch
                    data-testid="status-toggle"
                    checkedChildren={`${t("active")}`}
                    unCheckedChildren={`${t("inactive")}`}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  label={`${t("status")}`}
                  name="isActive"
                  valuePropName="checked"
                >
                  <Switch
                    checkedChildren={`${t("active")}`}
                    unCheckedChildren={`${t("inactive")}`}
                    defaultChecked
                    disabled={true}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <AddEditModal
            form="BrandForm"
            open={open}
            setOpen={setOpen}
            name={<span>{Brand?.name}</span>}
            title={`${t("modal-brand")}`}
            id={id}
            isSaving={isSaving}
          />
        </Form>
      </Modal>
    </>
  );
};
